import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetFreespinOperation = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_ID_FREESPIN
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetFreespinOperationAction({
                    data: data.data,
                    count: data.count,
                    allPage: data.allPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetFreespinOperation as SetGetFreespinOperation
}